import React from "react";
import Link from "next/link";

interface CTABandProps {
  onClaim?: () => void;
}

export default function CTABand({ onClaim }: CTABandProps) {
  return (
    <section className="cta-band" data-screen-label="CTA">
      <div className="cta-glow"></div>
      <div className="wrap cta-inner">
        <span className="eyebrow" data-reveal>YOUR ADVENTURE AMONG THE STARS BEGINS HERE</span>
        <h2 className="h-xl cta-h" data-reveal>STAKE YOUR<br /><span className="grad">CLAIM</span></h2>
        <p className="lead cta-lead" data-reveal>Pick a region of Mars, a crater on the Moon, or a star with your name on it. Verify it. Own it forever.</p>
        <div className="cta-btns" data-reveal>
          <Link className="btn btn-primary" href="/real-estate/mars" onClick={onClaim}>CLAIM A PIECE OF MARS <span className="ar">→</span></Link>
          <Link className="btn btn-ghost" href="/real-estate/moon">BROWSE THE MOON</Link>
        </div>
      </div>
    </section>
  );
}
